module.exports = __webpack_public_path__ + "img/3d96a57.png";